import script from "./ProfilePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilePanel.vue?vue&type=script&setup=true&lang=js"

import "./ProfilePanel.vue?vue&type=style&index=0&id=8c0d5124&lang=scss"

const __exports__ = script;

export default __exports__